// Composition root: the only file that sees every layer.
// - Mounts the UI (#ui) into #ui-root first, so the boot screen paints immediately.
// - Lazy-loads the engine (#engine) and content (#content), keeping both out of the entry chunk.
// - Passes the content into the engine and its string table into the UI.

import { assert, createLogger } from '#shared'
import { mountUi } from '#ui'

const log = createLogger('main')

const canvas = document.getElementById('game-canvas')
const uiRoot = document.getElementById('ui-root')
assert(canvas instanceof HTMLCanvasElement, 'Missing <canvas id="game-canvas"> in index.html')
assert(uiRoot, 'Missing <div id="ui-root"> in index.html')

const ui = mountUi(uiRoot)

try {
  const [{ createGame }, { gameContent }] = await Promise.all([
    import('#engine'),
    import('#content'),
  ])
  // `?level=<id>` jumps straight to a level; an unknown id shows the error screen.
  const initialLevelId =
    new URLSearchParams(location.search).get('level') ?? gameContent.defaultLevelId
  ui.attach(createGame({ canvas, initialLevelId, ...gameContent.engine }), gameContent.strings)
} catch (error) {
  log.error('Engine failed to load', error)
  ui.fail(error)
}
